import { Button, Form, Input, message, Modal, Space, Typography } from "antd";
import { useCallback, useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import axiosInstance, { endpoints } from "services/axios";
import { BooleanReturnType } from "hooks/use-boolean";
import { IPartnerCompany } from "models";

const CompanyDialog = ({ modalBool, refetch }: { modalBool: BooleanReturnType; refetch: any }) => {
  const [form] = Form.useForm();
  const editing: IPartnerCompany | undefined = modalBool.data;

  useEffect(() => {
    if (modalBool.value) form.setFieldsValue({ name: editing?.name });
  }, [modalBool.value, editing, form]);

  const { mutate: saveCompany, isPending } = useMutation({
    mutationFn: async (data: { name: string }) =>
      editing
        ? await axiosInstance.put(endpoints.partner.company, { id: editing.id, ...data })
        : await axiosInstance.post(endpoints.partner.company, data),
    onSuccess: () => {
      message.success("Saqlandi!");
      cancel();
    },
  });

  const onFinish = useCallback((data: { name: string }) => saveCompany(data), [saveCompany]);

  const cancel = () => {
    modalBool.onFalse();
    form.resetFields();
    refetch();
  };

  return (
    <Modal
      open={modalBool.value}
      title={
        <Typography.Title className="m-0" level={5}>
          {editing ? "Kompaniyani tahrirlash" : "Kompaniya qo'shish"}
        </Typography.Title>
      }
      closable={false}
      footer={null}
      destroyOnClose
    >
      <Form onFinish={onFinish} form={form} layout="vertical">
        <Form.Item name="name" label="Kompaniya nomi" rules={[{ required: true, message: "Kompaniya nomini kiriting!" }]}>
          <Input placeholder="Masalan: Acme LLC" />
        </Form.Item>

        <Form.Item className="flex justify-end mb-0">
          <Space>
            <Button onClick={cancel}>Bekor qilish</Button>
            <Button loading={isPending} type="primary" htmlType="submit">
              Saqlash
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CompanyDialog;
